import { createFileRoute } from '@tanstack/react-router'
import { AuditLogsPage } from '@/features/admin-settings/components/audit-logs-page'

export const Route = createFileRoute(
  '/_authenticated/admin-settings/audit-logs'
)({
  component: AuditLogsPage,
})
